var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeading", {
        attrs: {
          text: "Исторические личности",
          mode: "grid",
          "grid-data-loading": _vm.gridDataLoading,
          "results-count": _vm.resultsCount,
        },
        scopedSlots: _vm._u(
          [
            {
              key: `toolbar.prepend`,
              fn: function () {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2 mt-2",
                      attrs: {
                        link: "",
                        small: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "page-historical-figure-new",
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { small: "" } },
                        [_vm._v(" mdi-plus ")]
                      ),
                      _vm._v(" Добавить историческую личность "),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("v-row", [_c("v-col", [_c("GridStreams", { ref: "grid" })], 1)], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }